// 이 브라우저(앱)에만 기억하는 켬/끔 설정 — 사람마다 습관이 다른 세션 화면 선택(단축키 연동·끌어내기 등).
//
// 저장소를 못 쓰는 환경(사생활 모드·저장 차단)에서도 던지지 않는다 — 그때는 기본값으로 읽히고 이번 창에서만 유지된다.
// 저장 형식은 '1'/'0'(종전 클립보드 단축키 설정 `rs.clip.shortcuts` 와 같은 값 — 기존 사용자 설정이 그대로 읽힌다).

/** 기억해 둔 켬/끔을 읽는다. 저장된 값이 없거나 읽을 수 없으면 `fallback`. */
export function loadFlag(key: string, fallback: boolean): boolean {
  try {
    const v = localStorage.getItem(key);
    return v === null ? fallback : v !== '0';
  } catch {
    return fallback;
  }
}

/** 켬/끔을 기억한다(실패는 조용히 넘긴다 — 이번 창에서만 유지). */
export function saveFlag(key: string, on: boolean): void {
  try {
    localStorage.setItem(key, on ? '1' : '0');
  } catch {
    // 저장 불가(사생활 모드 등)
  }
}
